// src/components/SEOController.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NO_INDEX_PATHS = [
  '/editor',
  '/dashboard',
  '/imagemaptest',
  '/model-test',
  '/modeltest',
  '/testpage',
  '/developer'
];

// Public paths that SHOULD be indexed (optional - for clarity)
const PUBLIC_PATHS = [
  '/',
  '/pricing',
  '/features',
  '/support',
  '/blog',
  '/careers',
  '/press',
  '/partnerships',
  '/terms',
  '/privacy',
  '/acknowledgements',  // ADD THIS - makes it indexable
  '/auth'
];

const SEOController = () => {
  const location = useLocation();

  useEffect(() => {
    // Get or create robots meta tag
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      document.head.appendChild(robotsMeta);
    }

    // Check if current path should be no-indexed
    const shouldNoIndex = NO_INDEX_PATHS.some(path => 
      location.pathname === path || location.pathname.startsWith(path + '/')
    );

    if (shouldNoIndex) {
      robotsMeta.content = 'noindex, nofollow';
      console.log(`🔒 Blocking indexing for: ${location.pathname}`);
    } else {
      robotsMeta.content = 'index, follow';
      console.log(`✅ Allowing indexing for: ${location.pathname}`);
    }
  }, [location.pathname]);

  return null;
};

export default SEOController;